import { useEffect, useState } from "react";

// Shows the uploaded logo only; falls back to the showroom name if missing or broken.
export const BrandLogo = ({ src, name, imgClassName = "", imgStyle, nameClassName = "", nameStyle, testid = "brand" }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [src]);
  if (src && !failed) {
    return <img src={src} alt={name} className={imgClassName} style={imgStyle} onError={() => setFailed(true)} data-testid={`${testid}-logo`} />;
  }
  return <span className={nameClassName} style={nameStyle} data-testid={`${testid}-name`}>{name}</span>;
};

export const isExternalImage = (url) => {
  if (!url || url.startsWith("/") || url.startsWith("data:")) return false;
  try {
    const host = new URL(url).host;
    return host !== window.location.host && host !== new URL(process.env.REACT_APP_BACKEND_URL).host;
  } catch { return false; }
};
